import React from 'react';
import styles from "./IlustracinZoom.module.css";

const IlustracinZoom = ({ onClose ,image}) => {
  const containerRef = React.useRef(null);

  function moverScrollConMouse(evento) {
    const { offsetX, offsetY } = obtenerOffset(evento);
    containerRef.current.scrollTop = offsetY ;
    containerRef.current.scrollLeft = offsetX;
  }

  function obtenerOffset(evento) {
    const rect = containerRef.current.getBoundingClientRect();
    return {
      offsetX: evento.clientX - rect.left,
      offsetY: evento.clientY - rect.top-0.15,
    };
  }

  React.useEffect(()=>{
    if(containerRef){
      const container = containerRef.current;
      container.addEventListener("scroll",()=>{
        console.log("debug ddd::",container.scrollTop);
      })
    }
  },[])

  return (
    <div className={styles.ilustracinZoom}   >
      <img
        onClick={()=>onClose()} 
        className={styles.closeButtonIcon}
        alt=""
        src="../close-button1.svg"
        style={{cursor:'pointer'}}
      />
      <div ref={containerRef} onMouseMove={moverScrollConMouse}  className={styles.zoomedIllustration}>
        <img draggable={false} className={styles.imgIcon} alt="" src={image} />
      </div>
    </div>
  );
};

export default IlustracinZoom;
